import React from 'react';
import './_list.twig.editor.scss'
import './_list.twig.editor.dark-mode.scss'
import { Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ModalsManager from './Modals/Manager';
import ThemeItem from './ThemeItem';

const ListTwig = ({
  items,
  isLoading,
  onActivateTheme,
  onUpdateList,
}) => {
  const [modal, setModal] = React.useState({
    openModalKey: null,
    data: {},
  });

  const onCloseModal = () => {
    setModal({
      openModalKey: null,
      data: {},
    })
  }

  const onOpenModal = (openModalKey, data) => {
    setModal((prevState) => ({
      ...prevState,
      openModalKey,
      data,
    }))
  }

  const onSubmitModal = () => {
    onCloseModal();
    onUpdateList()
  }

  return (
    <>
      <ModalsManager
        modal={modal}
        onHide={onCloseModal}
        onSubmit={onSubmitModal}
      />
      <div className="list-twig">
        {isLoading ? <div className="modal-loader" /> : null }
        <Row>
          {items.map((item) => (
            <ThemeItem key={`theme-${item.id}`} item={item} isLoading={isLoading} onActivateTheme={onActivateTheme} onOpenModal={onOpenModal} />
          ))}
        </Row>
      </div>
    </>
  );
}

ListTwig.propTypes = {
  items: PropTypes.array,
  isLoading: PropTypes.bool,
  onActivateTheme: PropTypes.func,
  onUpdateList: PropTypes.func,
};

export default ListTwig;
